/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MassPaymentExportFormat } from './massPaymentExportFormat.model';


export interface BankProduct { 
    batchNumberSupported?: boolean;
    exportFormat?: MassPaymentExportFormat;
    fileLimit?: number;
    id?: string;
    name?: string;
}
export namespace BankProduct {
}


